"use client";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { SelectItem as c, SelectItemText as n } from "../../atoms/Select/Select.mjs";
import { cn as d } from "../../../utils/utils.mjs";
const o = ({ className: r, icon: t, children: a, ...s }) => /* @__PURE__ */ l(
  c,
  {
    className: d(
      "flex items-center gap-2 px-4 py-2 dark:text-neutral-dark-1000 dark:hover:bg-neutral-dark-400 dark:data-[state=checked]:bg-neutral-dark-400 dark:focus:bg-neutral-dark-400",
      r
    ),
    ...s,
    children: [
      t && /* @__PURE__ */ e("span", { className: "shrink-0 size-4 [&_path]:fill-white", children: t }),
      /* @__PURE__ */ e(n, { fontWeight: "regular", children: /* @__PURE__ */ e("span", { children: a }) })
    ]
  }
);
export {
  o as MediaSelectItem
};
